import { getResponsiveStyles } from '../../../component-themes';
export const energyLabelClassificationImageBase = (tokens) => ({ size }) => {
    return {
        width: 'auto',
        height: tokens.styles[`energylabel-classification-image-${size}-height`],
    };
};
export const energyLabelClassificationImage = (tokens) => ({ size, }) => getResponsiveStyles(size, (size) => energyLabelClassificationImageBase(tokens)({ size }));
